var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultBackground',[_c('div',{staticClass:"mt-12 mx-auto flex w-1/3 justify-center"},[_c('spinner',{attrs:{"orange":true}}),_c('span',{staticClass:"text-xl ml-3"},[_vm._v("Loading, please wait...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }